(() => {
  'use strict';

  function initProduct(section) {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';

    const dataNode = section.querySelector('[data-product-data]');
 const variantSelect = section.querySelector('[data-variant-select]');
const variantInput = section.querySelector('[data-variant-id-input]');
const qty = section.querySelector('[name="quantity"]');
    const submit = section.querySelector('[data-add-to-cart]');
    const price = section.querySelector('[data-product-price]');
    if (!dataNode || !variantSelect || !qty || !submit || !price) return;

    const data = JSON.parse(dataNode.textContent);
    const mediaItems = [...section.querySelectorAll('[data-media-id]')];
    const zoomButton = section.querySelector('[data-media-zoom]');
    const zoomDialog = section.querySelector('[data-product-zoom-dialog]');
    const zoomImage = section.querySelector('[data-product-zoom-image]');

    const updateZoom = () => {
      const activeMedia = mediaItems.find(media => !media.hidden);
      const activeImage = activeMedia?.querySelector('img');
      if (zoomButton) zoomButton.hidden = !activeImage;
      if (activeImage && zoomImage) {
        zoomImage.src = activeImage.currentSrc || activeImage.src;
        zoomImage.alt = activeImage.alt || '';
      }
    };

    const showMedia = id => {
      if (!mediaItems.some(item => item.dataset.mediaId === String(id))) return;
      mediaItems.forEach(item => { item.hidden = item.dataset.mediaId !== String(id); });
      section.querySelectorAll('[data-media-target]').forEach(link => {
        link.setAttribute('aria-current', String(link.dataset.mediaTarget === String(id)));
      });
      updateZoom();
    };

    section.querySelectorAll('[data-media-target]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      showMedia(link.dataset.mediaTarget);
    }));

    function update(updateUrl = false) {
      const variant = data.variants.find(item => String(item.id) === variantSelect.value);
      if (!variant) return;

      if (variantInput) {
  variantInput.value = variant.id;
  variantInput.setAttribute('value', String(variant.id));
  variantInput.dispatchEvent(new Event('change', { bubbles: true }));
}

      price.replaceChildren();
      const amount = document.createElement('span');
      amount.className = 'je-price';
      amount.textContent = variant.price;
      price.append(amount);
      if (variant.compare) {
        const compare = document.createElement('s');
        compare.textContent = variant.compare;
        price.append(' ', compare);
      }

      const available = variant.available;
      submit.disabled = !available;
      submit.textContent = available ? data.addLabel : data.soldOutLabel;
      if (!available) {
        submit.style.opacity = '0.6';
        submit.style.cursor = 'not-allowed';
      } else {
        submit.style.opacity = '1';
        submit.style.cursor = 'pointer';
      }

      const badge = section.querySelector('.je-stock-badge');
      if (badge) {
        if (!available) {
          badge.textContent = 'OUT OF STOCK';
          badge.style.background = '#000000';
          badge.style.color = '#ffffff';
          badge.style.boxShadow = '2px 2px 0 rgba(0,0,0,0.5)';
        } else {
          badge.textContent = data.badgeLabel || 'BESTSELLER';
          badge.style.background = '#F3EAD4';
          badge.style.color = '#000000';
          badge.style.boxShadow = '2px 2px 0 #000';
        }
      }

      qty.min = variant.min;
      qty.step = variant.increment;
      if (variant.max != null) qty.max = variant.max;
      else qty.removeAttribute('max');
      let value = Math.max(variant.min, Number(qty.value) || variant.min);
      value = variant.min + Math.ceil((value - variant.min) / variant.increment) * variant.increment;
      if (variant.max != null) value = Math.min(value, variant.max);
      qty.value = value;

      showMedia(variant.media || mediaItems[0]?.dataset.mediaId);
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }

    variantSelect.addEventListener('change', () => update(true));
    section.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
      if (Number(button.dataset.quantityStep) > 0) qty.stepUp();
      else qty.stepDown();
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    qty.addEventListener('change', () => update());

    zoomButton?.addEventListener('click', () => {
      updateZoom();
      if (zoomImage?.src) zoomDialog?.showModal();
    });
    zoomDialog?.querySelector('[data-media-zoom-close]')?.addEventListener('click', () => zoomDialog.close());
    zoomDialog?.addEventListener('click', event => {
      if (event.target === zoomDialog) zoomDialog.close();
    });

    update();
  }

  function initJunip() {
    const storeKey = document.querySelector('.junip-store-key[data-store-key]');
    if (!storeKey || !document.querySelector('[data-junip-summary]')) return;
    if (document.querySelector('script[src*="widgets.juniphq.com/v1/junip_shopify.js"]')) return;
    const script = document.createElement('script');
    script.src = 'https://widgets.juniphq.com/v1/junip_shopify.js';
    script.async = true;
    document.head.append(script);
  }

  function initPromotion(popup) {
    if (popup.dataset.initialized) return;
    popup.dataset.initialized = 'true';
    const inDesignMode = popup.dataset.designMode === 'true';
    if (!inDesignMode && popup.dataset.homepageOnly === 'true' && popup.dataset.isHomepage !== 'true') return;

    const storageKey = popup.dataset.storageKey;
    const rememberDismissal = !inDesignMode && popup.dataset.frequency === 'session';
    if (rememberDismissal) {
      try {
        if (sessionStorage.getItem(storageKey) === 'dismissed') return;
      } catch (error) {
        // Storage can be unavailable in strict privacy contexts; the popup still works.
      }
    }

    const dismiss = () => {
      popup.hidden = true;
      if (rememberDismissal) {
        try { sessionStorage.setItem(storageKey, 'dismissed'); } catch (error) { /* no-op */ }
      }
    };
    popup.querySelector('[data-promotion-close]')?.addEventListener('click', dismiss);

    const delay = inDesignMode ? 0 : Math.max(0, Number(popup.dataset.delay) || 0);
    window.setTimeout(() => { popup.hidden = false; }, delay);
  }

  function applyPageHeaderOverride() {
    const controller = document.querySelector('[data-page-header-style]');
    if (!controller) return;

    const setImportant = (element, property, value) => {
      if (element && value) element.style.setProperty(property, value, 'important');
    };

    const header = document.querySelector('.je-header');
    const navbarBackground = controller.dataset.navbarBackground;
    const navbarText = controller.dataset.navbarText;
    setImportant(header, '--header-color', navbarBackground);
    setImportant(header, '--header-text-color', navbarText);
    setImportant(header, 'background', navbarBackground);
    setImportant(header, 'background-color', navbarBackground);
    document.querySelectorAll('.je-header a, .je-header summary').forEach(element => {
      setImportant(element, 'color', navbarText);
    });

    const announcement = document.querySelector('.je-announcement');
    const ribbonBackground = controller.dataset.ribbonBackground;
    const ribbonTextColor = controller.dataset.ribbonTextColor;
    setImportant(announcement, '--announcement-bg', ribbonBackground);
    setImportant(announcement, '--announcement-text', ribbonTextColor);
    setImportant(announcement, 'background', ribbonBackground);
    setImportant(announcement, 'background-color', ribbonBackground);
    setImportant(announcement, 'color', ribbonTextColor);
    if (announcement) {
      const override = (controller.dataset.ribbonText || '').trim();
      announcement.textContent = override || announcement.dataset.defaultAnnouncement || '';
    }

    const headerButton = document.querySelector('.je-header-cta');
    const buttonBackground = controller.dataset.buttonBackground;
    const buttonTextColor = controller.dataset.buttonTextColor;
    const buttonShadow = controller.dataset.buttonShadow;
    setImportant(headerButton, '--button-bg', buttonBackground);
    setImportant(headerButton, '--button-text', buttonTextColor);
    setImportant(headerButton, '--accent', buttonShadow);
    setImportant(headerButton, 'background', buttonBackground);
    setImportant(headerButton, 'background-color', buttonBackground);
    setImportant(headerButton, 'color', buttonTextColor);
    if (buttonShadow) setImportant(headerButton, 'box-shadow', `0 4px 0 ${buttonShadow}`);
    if (headerButton) {
      const buttonOverride = (controller.dataset.headerButtonText || '').trim();
      headerButton.textContent = buttonOverride || headerButton.dataset.defaultLabel || '';
    }
  }

  function init(root = document) {
    // Always reapply after any Shopify section reload. The Header and this
    // per-page controller are separate sections in the theme editor.
    applyPageHeaderOverride();

    root.querySelectorAll('[data-product-section]').forEach(initProduct);
    root.querySelectorAll('[data-promotion-popup]').forEach(initPromotion);
    initJunip();

    root.querySelectorAll('[data-account-dialog-open]').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const dialog = document.querySelector('[data-account-dialog]');
        if (dialog?.showModal) dialog.showModal();
        else if (button.dataset.loginUrl) window.location.href = button.dataset.loginUrl;
      });
    });

    root.querySelectorAll('[data-account-dialog]').forEach(dialog => {
      if (dialog.dataset.initialized) return;
      dialog.dataset.initialized = 'true';
      dialog.addEventListener('click', event => {
        if (event.target === dialog) dialog.close();
      });
    });

    root.querySelectorAll('[data-faq-filters]').forEach(filters => {
      if (filters.dataset.initialized) return;
      filters.dataset.initialized = 'true';
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-faq-category]');
        if (!button) return;
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        filters.parentElement.querySelectorAll('[data-faq-item]').forEach(item => {
          item.hidden = button.dataset.faqCategory !== 'all' && item.dataset.category !== button.dataset.faqCategory;
        });
      });
    });

    root.querySelectorAll('[data-tabs]').forEach(tabs => {
      if (tabs.dataset.initialized) return;
      tabs.dataset.initialized = 'true';
      const buttons = [...tabs.querySelectorAll('[role="tab"]')];
      function activate(button) {
        buttons.forEach(item => {
          item.setAttribute('aria-selected', String(item === button));
          item.tabIndex = item === button ? 0 : -1;
        });
        tabs.querySelectorAll('[role="tabpanel"]').forEach(panel => {
          panel.hidden = panel.id !== button.getAttribute('aria-controls');
        });
      }
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(button));
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = buttons[(index + 1) % buttons.length];
          if (event.key === 'ArrowLeft') next = buttons[(index - 1 + buttons.length) % buttons.length];
          if (event.key === 'Home') next = buttons[0];
          if (event.key === 'End') next = buttons.at(-1);
          if (next) {
            event.preventDefault();
            activate(next);
            next.focus();
          }
        });
      });
    });

    root.querySelectorAll('[data-store-search]').forEach(input => {
      if (input.dataset.initialized) return;
      input.dataset.initialized = 'true';
      input.addEventListener('input', () => {
        const section = input.closest('section');
        let count = 0;
        section.querySelectorAll('[data-store]').forEach(store => {
          store.hidden = !store.textContent.toLowerCase().includes(input.value.trim().toLowerCase());
          if (!store.hidden) count += 1;
        });
        section.querySelector('[data-store-status]').textContent = count
          ? `${count} store${count === 1 ? '' : 's'} found`
          : 'No matching stores. Try another city or contact us.';
        const empty = section.querySelector('[data-store-empty]');
        if (empty) empty.hidden = count !== 0;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.je-header details[open]').forEach(details => {
        details.open = false;
        details.querySelector('summary').focus();
      });
      document.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
    }
  });
})();

/* Keep the large PDP price synchronized with Loop's selected purchase option. */
(() => {
  'use strict';

  function syncLoopSelectedPrice() {
    document.querySelectorAll('[data-product-section]').forEach(section => {
      const displayedPrice = section.querySelector('[data-product-price]');
      if (!displayedPrice) return;

      const selectedOption = section.querySelector(
        '.loop-w-btn-group-purchase-option-selected, .loop-widget-purchase-option-selected, ' +
        '[data-loop-widget-purchase-option][aria-checked="true"]'
      );
      if (!selectedOption) return;

      const prices = Array.from(
        selectedOption.querySelectorAll('.loop-w-btn-group-purchase-option-price, .loop-widget-purchase-option-price')
      );
      const selectedPrice = prices.find(price => {
        const styles = window.getComputedStyle(price);
        return !price.classList.contains('loop-display-none') &&
          styles.display !== 'none' &&
          styles.visibility !== 'hidden';
      });
      const priceText = selectedPrice?.textContent.replace(/\s+/g, ' ').trim();

      if (!priceText || displayedPrice.textContent.trim() === priceText) return;

      const amount = document.createElement('span');
      amount.className = 'je-price';
      amount.textContent = priceText;
      displayedPrice.replaceChildren(amount);
    });
  }

  function queueLoopPriceSync() {
    window.requestAnimationFrame(syncLoopSelectedPrice);
    window.setTimeout(syncLoopSelectedPrice, 100);
  }

  document.addEventListener('click', event => {
    if (event.target.closest(
      '[data-loop-widget-purchase-option], .loop-widget-purchase-option, .loop-widget-sp-selector'
    )) {
      queueLoopPriceSync();
    }
  }, true);

  document.addEventListener('change', event => {
    if (event.target.matches(
      '.loop-widget-sp-selector, input[name="selling_plan"], select[name="selling_plan"]'
    )) {
      queueLoopPriceSync();
    }
  }, true);

  const loopObserver = new MutationObserver(queueLoopPriceSync);

  function startLoopPriceSync() {
    loopObserver.disconnect();
    loopObserver.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-checked', 'class']
    });
    queueLoopPriceSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startLoopPriceSync, { once: true });
  } else {
    startLoopPriceSync();
  }

  document.addEventListener('shopify:section:load', queueLoopPriceSync);
})();
